/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import EnterpriseComponentsConfigRenderer from 'bundles/page-config-common/components/EnterpriseComponentsConfigRenderer';
import { useComponentsConfig } from 'bundles/page-config-common/contexts/ComponentsConfigContext';
import EnterpriseDomainSelectorNotConfigurableModule from 'bundles/unified-home-common/components/enterprise/EnterpriseDomainSelectorNotConfigurable';
import ProgramForceSSONotification from 'bundles/unified-home-common/components/enterprise/ProgramForceSSONotifications';
import NotificationModuleRenderer from 'bundles/unified-home-common/module-renderers/NotificationModuleRenderer';
import EnterpriseBannerNonConfigurable from 'bundles/unified-home-common/pages/enterprise/EnterpriseBannerNonConfigurable';

const styles = {
  wrapper: css`
    & > :nth-child(even) {
      background-color: var(--cds-color-neutral-disabled-weak);

      & .single-lp {
        background-color: var(--cds-color-white-0);
      }
    }
  `,
};

const EnterpriseHomePageRootContent = () => {
  const pageConfigComponents = useComponentsConfig();

  return (
    <React.Fragment>
      <NotificationModuleRenderer />
      <EnterpriseDomainSelectorNotConfigurableModule />
      <EnterpriseBannerNonConfigurable isProgramDetailsView={true} shouldShowJoinButton={false} />
      <ProgramForceSSONotification />
      <div css={styles.wrapper} data-testid="enterprise-home-page">
        <EnterpriseComponentsConfigRenderer pageConfigComponents={pageConfigComponents} />
      </div>
    </React.Fragment>
  );
};

export default EnterpriseHomePageRootContent;
